/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRequestBody,
  CreateRequestBody$Outbound,
  CreateRequestBody$outboundSchema,
} from "../components/createrequestbody.js";

export type CreateChatSessionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateChatSessionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateChatSessionSecurity = {
  option1?: CreateChatSessionSecurityOption1 | undefined;
  option2?: CreateChatSessionSecurityOption2 | undefined;
};

export type CreateChatSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRequestBody: CreateRequestBody;
};

/** @internal */
export type CreateChatSessionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateChatSessionSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateChatSessionSecurityOption1$Outbound,
  CreateChatSessionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createChatSessionSecurityOption1ToJSON(
  createChatSessionSecurityOption1: CreateChatSessionSecurityOption1,
): string {
  return JSON.stringify(
    CreateChatSessionSecurityOption1$outboundSchema.parse(
      createChatSessionSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateChatSessionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateChatSessionSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateChatSessionSecurityOption2$Outbound,
  CreateChatSessionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createChatSessionSecurityOption2ToJSON(
  createChatSessionSecurityOption2: CreateChatSessionSecurityOption2,
): string {
  return JSON.stringify(
    CreateChatSessionSecurityOption2$outboundSchema.parse(
      createChatSessionSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateChatSessionSecurity$Outbound = {
  Option1?: CreateChatSessionSecurityOption1$Outbound | undefined;
  Option2?: CreateChatSessionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateChatSessionSecurity$outboundSchema: z.ZodMiniType<
  CreateChatSessionSecurity$Outbound,
  CreateChatSessionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateChatSessionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateChatSessionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createChatSessionSecurityToJSON(
  createChatSessionSecurity: CreateChatSessionSecurity,
): string {
  return JSON.stringify(
    CreateChatSessionSecurity$outboundSchema.parse(createChatSessionSecurity),
  );
}

/** @internal */
export type CreateChatSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRequestBody: CreateRequestBody$Outbound;
};

/** @internal */
export const CreateChatSessionRequest$outboundSchema: z.ZodMiniType<
  CreateChatSessionRequest$Outbound,
  CreateChatSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRequestBody: CreateRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createRequestBody: "CreateRequestBody",
    });
  }),
);

export function createChatSessionRequestToJSON(
  createChatSessionRequest: CreateChatSessionRequest,
): string {
  return JSON.stringify(
    CreateChatSessionRequest$outboundSchema.parse(createChatSessionRequest),
  );
}
